module.exports = __webpack_public_path__ + "static/media/Luxury.d91d1462.png";